import router from '@/router';
import store from '@/store';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth'; // 验权

// 查找一个有权限的页面
const findToRouter = () => {
  const allRouters = router.options.routes;
  const excludes = ['/login', '*'];
  for (let i = 0; i < allRouters.length; i += 1) {
    const first = allRouters[i];
    if (!excludes.includes(first.path) && first.children) {
      for (let j = 0; j < first.children.length; j += 1) {
        const second = first.children[j];
        const toPath = first.path + (second.path.indexOf('/') === 0 ? second.path : `/${second.path}`);
        if (store.getters.groups.some(g => g.test(toPath))) {
          return toPath;
        }
      }
    }
  }
  return null;
};

const whiteList = ['/login', '/modifyPassword', '/register','/map/scopeLabeling',]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  // NProgress.start();
  if (getToken() && !whiteList.includes(to.path)) {
    if (!store.getters.name) {
      store
        .dispatch('GetInfo')
        .then((res) => {
          // 拉取用户信息
          if (store.getters.groups.some(g => g.test(to.path))) {
            next();
          } else {
            Message.warning(`没有权限访问此页面（${to.path}），请联系管理员`);
            if (from.path === '/login') {
              const toPath = findToRouter();
              if (toPath) {
                next({ path: toPath });
              } else {
                next({ path: '/login' });
              }
            } else {
              next({ path: '/login' });
            }
            // NProgress.done();
          }
        })
        .catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/login' });
          });
        });
    } else if (store.getters.groups.length < 1) {
      Message.warning('该用户没有配置权限，请联系管理员');
      next({ path: '/login' });
    } else if (store.getters.groups.some(g => g.test(to.path))) {
      next();
    } else {
      Message.warning(`没有权限访问此页面（${to.path}），请联系管理员`);
      if (from.path === '/login') {
        const toPath = findToRouter();
        if (toPath) {
          next({ path: toPath });
        } else {
          next({ path: from.path });
        }
      } else {
        next({ path: from.path });
      }
      // NProgress.done();
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
    // NProgress.done();
  }
});

router.afterEach(() => {
  // NProgress.done(); // 结束Progress
});
